import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function pagosComboReducer(state= initialState.pagosCombo, action){
	switch(action.type){
		case types.GET_PAGOSS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}